import * as uuid from 'uuid'

export class UserManager {

  static createGuestUser(botIdentity) {
    const guestAccount = {
      userIdentity: `${uuid.v4()}.${botIdentity}`,
      userPassword: btoa(uuid.v4()),
    }

    return guestAccount
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/utils/UserManager.ts